Vue.component("instagram-feed", {

    template: `<div>
    <div class="instagram-loader loading" ref="instaLoader"><loading-animation class="w-100"></loading-animation></div>
    <div class="instagram-carousel owl-carousel owl-theme" ref="insta">
        <template v-for="(media, index) in getMediaData">
            <div class="item" :style="{ background: itemBgColor }">
                <a :href="media.permalink" target="_blank" class="insta-item" :data-id="media.id" :aria-label="getAltText(media.alt_text, index)">
                    <img class="inst-image owl-lazy" :data-src="getThumbnail(media)" :alt="getAltText(media.alt_text, index)" />
                    <div class="overlay">
                        <div class="overlay-bg" :style="{ background: overlayBgColor }"></div>
                    </div>
                </a>
            </div>
        </template>
    </div>
    <div class="modal fade instagram-modal" tabindex="-1" role="dialog" ref="instaModal">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-body">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <div class="insta-modal-container">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <a class="image-link" href="#" target="_blank">
                          <img class="image" src="" />
                        </a>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="user-container">
                          <a class="user-link" href="#" target="_blank">
                            <span class="user-name"></span>
                          </a>
                        </div>
                        <div class="caption"></div>
                        <div class="tags"></div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>`,

    props: {
        mediaData: {
            type: Array
        },
        openInPopup: {
            type: Boolean,
            default: true
        },
        imageLimit: {
            type: Number,
            default: 10
        },
        responsiveOne: {
            type: Number,
            default: 1
        },
        responsiveTwo: {
            type: Number,
            default: 3
        },
        responsiveThree: {
            type: Number,
            default: 6
        },
        itemBgColor: {
            type: String,
            default: "#fff"
        },
        overlayBgColor: {
            type: String,
            default: "#fff"
        }
    },

    computed:
    {
        getMediaData()
        {
            return this.mediaData.slice(0, this.imageLimit);
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initInstaFeed();
        });
    },

    methods: {
        getAltText(alt, index)
        {
            return alt ? alt : `Instagram Bild ${index + 1}`;
        },
        updateHeight()
        {
            const width = $(this.$refs.insta).find(".owl-item").first().width();

            if (width)
            {
                $(this.$refs.insta).find(".item").css("height", width + "px");
                $(this.$refs.insta).find(".inst-image").css("max-height", width + "px");
            }
        },
        getThumbnail(media)
        {
            return media.thumbnail_url ? media.thumbnail_url : media.media_url;
        },
        getHashTags(inputText)
        {
            const regex = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
            const matches = [];
            let match;

            while ((match = regex.exec(inputText)))
            {
                matches.push(match[1]);
            }

            return matches;
        },
        onImageClick(media)
        {
            const modal = $(this.$refs.instaModal);

            modal.find(".image").attr("src", this.getThumbnail(media));
            modal.find(".image-link").attr("href", media.permalink);
            modal.find(".user-link").attr("href", "https://www.instagram.com/" + media.username);
            modal.find(".user-name").html(media.username);
            modal.find(".caption").html(media.caption);

            const tags = this.getHashTags(media.caption);

            if (tags.length)
            {
                let tagsHtml = "";
                let i = 0;

                tags.forEach(function(element)
                {
                    if (i > 0)
                    {
                        tagsHtml += ", ";
                    }
                    tagsHtml += "<a href=\"https://www.instagram.com/explore/tags/" + element + "\">#" + element + "</a>";
                    i++;
                });
                tagsHtml += ".";
                modal.find(".tags").html(tagsHtml);
            }
            else
            {
                modal.find(".tags").html("");
            }

            modal.modal("show");
        },
        initInstaFeed()
        {
            $(this.$refs.insta).owlCarousel({
                dots: false,
                loop: true,
                lazyLoad: true,
                margin: 10,
                nav: true,
                navContainerClass: "",
                navClass: [
                    "owl-insta-item-nav left carousel-control list-control-special",
                    "owl-insta-item-nav right carousel-control list-control-special"
                ],
                navText: [
                    `<i id="owl-nav-text-left-${this._uid}" class='owl-insta-item-control fa fa-chevron-left' aria-hidden='true'></i>`,
                    `<i id="owl-nav-text-right-${this._uid}" class='owl-insta-item-control fa fa-chevron-right' aria-hidden='true'></i>`
                ],
                responsiveClass: true,
                responsive: {
                    0: {
                        items: this.responsiveOne
                    },
                    600: {
                        items: this.responsiveTwo
                    },
                    1000: {
                        items: this.responsiveThree
                    }
                },
                onResized: event =>
                {
                    this.updateHeight();
                },
                onInitialized: event =>
                {
                    $(this.$refs.instaLoader).removeClass("loading");

                    this.updateHeight();

                    const left = document.querySelector(`#owl-nav-text-left-${this._uid}`);
                    const right = document.querySelector(`#owl-nav-text-right-${this._uid}`);

                    if (left && right)
                    {
                        left.parentElement.onclick = event => event.preventDefault();
                        right.parentElement.onclick = event => event.preventDefault();
                    }

                    if (this.openInPopup)
                    {
                        const _thisInsta = this;

                        $(this.$refs.insta).on("click", ".insta-item", function()
                        {
                            const id = $(this).data("id");
                            const media = _thisInsta.mediaData.find(media => media.id == id);

                            if (media.media_type == "IMAGE" || media.media_type == "CAROUSEL_ALBUM")
                            {
                                _thisInsta.onImageClick(media);
                                return false;
                            }
                            return true;
                        });
                    }
                }
            });
        }
    }
});
